import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import styles from "./StripeOnboardingModal.module.scss";

interface IProps {
  clubId: string;
  onCancel: () => void;
}

const StripeOnboardingModal: React.FC<IProps> = ({ clubId, onCancel }) => {
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    onCancel();
    navigate(`/k/${clubId}/manage/balances`);
  };

  return (
    <div className={styles.StripeOnboardingModal}>
      <h2 className={styles.title}>Stripe Setup Required</h2>
      <p className={styles.message}>
        In order to create events or courses, you must first complete or update your Stripe setup.
      </p>
      <div className={styles.actions}>
        <Button onClick={onCancel} className={styles.cancelBtn}>
          Cancel
        </Button>
        <Button onClick={handleGoToSettings} className={styles.primaryBtn}>
          Go to Stripe Settings
        </Button>
      </div>
    </div>
  );
};

export default StripeOnboardingModal;
